export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8440.d5786a74.jpg";